// Blocks
// import "./blocks/page/accordion";
// import "./blocks/page/quotes";
// import "./blocks/page/slider";
import "./blocks/page/our-story";

// Components
import "./components/nav/nav-a";
import "./components/nav/pusher";
import "./components/map";
import "./components/pizzeria-search-selects";
import "./components/pizzeria-search-input";

// Utilities
// import "./utilities/font-grid";
import "./utilities/register-trademark";

console.log("update");



// WEBPACK FOOTER //
// ./assets/js/app.js